import { uuidv7 } from "uuidv7";

export const generateId = () => {
  const id = uuidv7();
  return id;
};
